import React from 'react';

import { SecondaryTitle, Space } from '@/components';
import { AnyTransactionPeriod } from '@/model/wallets/types';

import { TransactionFilterTitleLabel, TransactionFilterTitlePeriod } from './components';

interface TransactionFilterTitleProps {
  'data-test'?: string;
  value: AnyTransactionPeriod;
}

export const TransactionFilterTitle: React.FC<TransactionFilterTitleProps> = ({ value, 'data-test': dataTest }) => (
  <Space direction="vertical" wrapItems size={0}>
    <SecondaryTitle data-test={dataTest && `${dataTest}-label`} style={{ color: '#999BBF' }}>
      <TransactionFilterTitleLabel value={value} />
    </SecondaryTitle>
    <TransactionFilterTitlePeriod data-test={dataTest && `${dataTest}-value`} value={value} />
  </Space>
);

export default React.memo(TransactionFilterTitle);
